import React, { useState } from "react";
import { Helmet } from "react-helmet";
import TestimonialSection from "./TestimonialSection"; // Assumed existing file
import Footer from "../../components/common/Footer";
import PressReleaseHero from "./PressReleaseHero";
import GallerySection from "./GallerySection";

// --- Data Definitions ---

// Gallery data
const galleryImagesData = [
  {
    id: 1,
    src: "/assets/gallery/Gallery1.png",
    title: "Lorem Ipsum Dolor Sit Amet 1",
    subtitle: "01/10",
  },
  {
    id: 2,
    src: "/assets/gallery/Gallery2.png",
    title: "Lorem Ipsum Dolor Sit Amet 2",
    subtitle: "02/10",
  },
  {
    id: 3,
    src: "/assets/farmersImg.png",
    title: "Lorem Ipsum Dolor Sit Amet 3",
    subtitle: "03/10",
  },
];

// Video testimonial data (passed to TestimonialSection)
const videoTestimonialsData = [
  {
    id: 1,
    thumbnail: "/images/img_rectangle_59.png",
    playIcon: "/images/img_vector.svg",
  },
  {
    id: 2,
    thumbnail: "/images/img_rectangle_57.png",
    playIcon: "/images/img_vector.svg",
  },
  {
    id: 3,
    thumbnail: "/images/img_rectangle_58.png",
    playIcon: "/images/img_vector.svg",
  },
];

// Press release cards data (passed to PressReleaseHero)
const pressReleasesData = [
  {
    id: 1,
    image: "/assets/gallery/gel.png",
    title: "Govardhannathji Energies LLP",
    description: "CBG into the CGD pipeline network",
  },
  {
    id: 2,
    image: "/assets/gallery/iocl.png",
    title: "IOCL",
    description: "Inauguration of CBG-CGD Synchronization",
  },
  {
    id: 3,
    image: "/assets/gallery/CBG.png",
    title: "CBG-CDG",
    description: "GAIL (India) Limited's Post",
  },
];

const PressReleaseGallery = () => {
  // Keeping state here if you need to manage global slide changes
  // or if the sub-components are fully controlled.
  // For this example, I'm passing the data and leaving slide logic
  // to be managed inside the sub-components for better encapsulation.
  const [currentGallerySlide, setCurrentGallerySlide] = useState(0);
  const [currentVideoSlide, setCurrentVideoSlide] = useState(0);

  return (
    <>
      <Helmet>
        <title>
          Press Release & Gallery | Utpann Organic Solutions - Government
          Partnerships & Facilities
        </title>
        <meta
          name="description"
          content="Explore Utpann's latest press releases featuring partnerships with IOCL and government agencies. View our state-of-the-art facilities and farmer testimonials showcasing organic fertilizer success stories."
        />
        {/* OG tags omitted for brevity */}
      </Helmet>
      <main className="w-full bg-background-main">
        {/* 1. Press Release Hero Section (with cards) */}
        <PressReleaseHero pressReleases={pressReleasesData} />

        {/* 2. Gallery Section */}
        <GallerySection
          galleryImages={galleryImagesData}
          currentSlide={currentGallerySlide}
          setCurrentSlide={setCurrentGallerySlide}
        />

        {/* 3. Testimonial Section */}
        {/* Pass videoTestimonialsData and currentVideoSlide/setters to TestimonialSection if needed */}
        <TestimonialSection
          videoTestimonials={videoTestimonialsData}
          currentVideoSlide={currentVideoSlide}
          setCurrentVideoSlide={setCurrentVideoSlide}
        />

        {/* 4. Footer Section */}
        <Footer />
      </main>
    </>
  );
};

export default PressReleaseGallery;
